/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Embed_DescInputs */



/**
* | output |
* | --- |
* | "Embed an AD track into MXF, MOV, MP4..." |
*
* @param {File_Export_Audio_Embed_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_embed_desc = /** @type {((inputs?: File_Export_Audio_Embed_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Embed_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrer une piste publicitaire dans un fichier MXF, MOV, MP4...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Werbespur in MXF, MOV, MP4 einbetten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorporare una traccia pubblicitaria in file MXF, MOV, MP4...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание рекламного блока в файлы MXF, MOV, MP4...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inserta una pista de audio en MXF, MOV, MP4...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 AD 音轨嵌入 MXF、MOV、MP4 等格式文件中……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MXF、MOV、MP4ファイルに広告音声トラックを埋め込む...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("MXF, MOV, MP4 आदि फ़ाइलों में विज्ञापन ट्रैक एम्बेड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorpore uma faixa de anúncio em MXF, MOV, MP4...")
	return /** @type {LocalizedString} */ ("Embed an AD track into MXF, MOV, MP4...")
});